import { IconButton, styled } from '@mui/material'

export const ShiftHeader = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSmallScreen',
})<{ isSmallScreen: boolean }>`
  position: relative;
  width: 100%;
  min-height: ${({ isSmallScreen, theme }) => theme.spacing(isSmallScreen ? 7 : 9)};
  gap: ${({ theme }) => theme.spacing(2)};
  box-sizing: border-box;
  border-bottom: 0.0625rem solid ${({ theme }) => theme.palette.common.divider};
`

export const TextContainer = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => theme.spacing(2)};
  transform: translateY(-50%);
`
